import React from 'react';
import './skill.css';
import {
  FaPython, FaReact, FaNodeJs, FaDocker, FaDatabase, FaJs, FaHtml5, FaCss3Alt,
  FaBootstrap, FaAws, FaNpm, FaJava, FaLanguage
} from 'react-icons/fa';
import { SiTypescript, SiTailwindcss, SiPostman, SiTensorflow, SiKeras, SiElectron, SiMongodb, SiThreedotjs } from 'react-icons/si';
import ThreeScene from '../profile/threescene';

// Categorize skills
const frontendSkills = [
  { name: 'ReactJS', icon: <FaReact /> },
  { name: 'React Native', icon: <FaReact /> },
  { name: 'Electron JS', icon: <SiElectron /> },
  { name: 'JavaScript', icon: <FaJs /> },
  { name: 'TypeScript', icon: <SiTypescript /> },
  { name: 'Three.js', icon: <SiThreedotjs /> }, // Added Three.js
  { name: 'Bootstrap', icon: <FaBootstrap /> },
  { name: 'Tailwind', icon: <SiTailwindcss /> },
  { name: 'HTML5', icon: <FaHtml5 /> },
  { name: 'CSS3', icon: <FaCss3Alt /> },
];

const backendSkills = [
  { name: 'Python', icon: <FaPython /> },
  { name: 'NodeJS', icon: <FaNodeJs /> },
  { name: 'Java', icon: <FaJava /> }, // Added Java
  { name: 'Flask', icon: <FaDatabase /> },
  { name: 'Django', icon: <FaDatabase /> },
  { name: 'Docker', icon: <FaDocker /> },
];

const databaseSkills = [
  { name: 'MySQL', icon: <FaDatabase /> },
  { name: 'MongoDB', icon: <SiMongodb /> },
  { name: 'Firebase', icon: <FaDatabase /> },
  { name: 'Supabase', icon: <FaDatabase /> },
];

const otherSkills = [
  { name: 'Postman', icon: <SiPostman /> },
  { name: 'Keras', icon: <SiKeras /> },
  { name: 'TensorFlow', icon: <SiTensorflow /> },
  { name: 'OpenCV', icon: <FaDatabase /> },
  { name: 'NLP', icon: <FaDatabase /> },
  { name: 'AWS', icon: <FaAws /> },
  { name: 'NPM', icon: <FaNpm /> },
];

const languageSkills = [
  { name: 'English', icon: <FaLanguage /> },
  { name: 'Hindi', icon: <FaLanguage /> },
  { name: 'Urdu', icon: <FaLanguage /> },
  { name: 'Tamil', icon: <FaLanguage /> },
  { name: 'Arabic', icon: <FaLanguage /> },
];

const Skills = () => {
  return (
    <div className="skills-container">
      <ThreeScene/>
      <h2 className="skills-category-title">Frontend</h2>
      <div className="skills-grid">
        {frontendSkills.map((skill, index) => (
          <div key={index} className="skill-item">
            <div className="skill-icon">{skill.icon}</div>
            <p className="skill-name">{skill.name}</p>
          </div>
        ))}
      </div>

      <h2 className="skills-category-title">Backend</h2>
      <div className="skills-grid">
        {backendSkills.map((skill, index) => (
          <div key={index} className="skill-item">
            <div className="skill-icon">{skill.icon}</div>
            <p className="skill-name">{skill.name}</p>
          </div>
        ))}
      </div>

      <h2 className="skills-category-title">Database</h2>
      <div className="skills-grid">
        {databaseSkills.map((skill, index) => (
          <div key={index} className="skill-item">
            <div className="skill-icon">{skill.icon}</div>
            <p className="skill-name">{skill.name}</p>
          </div>
        ))}
      </div>

      <h2 className="skills-category-title">Other Tools</h2>
      <div className="skills-grid">
        {otherSkills.map((skill, index) => (
          <div key={index} className="skill-item">
            <div className="skill-icon">{skill.icon}</div>
            <p className="skill-name">{skill.name}</p>
          </div>
          ))}
      </div>

      <h2 className="skills-category-title">Languages Known</h2>
      <div className="skills-grid">
        {languageSkills.map((skill, index) => (
          <div key={index} className="skill-item">
            <div className="skill-icon">{skill.icon}</div>
            <p className="skill-name">{skill.name}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Skills;
